/** Запросы, где 401 — ожидаемый ответ (неверный пароль и т.п.), без refresh и без редиректа. */
export const isAuthCredentialRequest = (config) => {
  if (!config?.url) return false;
  const url = String(config.url).toLowerCase();
  return url.includes('login/json') || url.includes('/register') || url.includes('/signup');
};

export const resolve401DetailMessage = (data) => {
  if (!data || typeof data !== 'object') return 'Требуется авторизация';
  if (typeof data.detail === 'string') return data.detail;
  if (Array.isArray(data.detail) && data.detail.length && typeof data.detail[0] === 'string') {
    return data.detail[0];
  }
  if (typeof data.message === 'string') return data.message;
  return 'Требуется авторизация';
};

/** Перенаправление на логин при истёкшей сессии (throttle 2 с через sessionStorage). */
export const safeRedirectToLogin = () => {
  if (typeof window === 'undefined') return;
  const path = window.location.pathname;
  if (path === '/login' || path.startsWith('/public/')) return;

  const now = Date.now();
  const key = 'auth_redirect_ts';
  const last = parseInt(sessionStorage.getItem(key) || '0', 10);
  if (now - last < 2000) return;
  sessionStorage.setItem(key, String(now));

  try {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  } catch {
    /* ignore */
  }
  window.location.replace('/login');
};
